/**
 * Cleans category/label text for display — strips C0 control chars and fixes
 * model artifacts (control char + literal "26" for &, bare & separators).
 */
export function normalizeInterviewLabel(value) {
	if (value == null || value === "") {
		return value;
	}
	let s = String(value).replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7F]/g, "");
	s = s.replace(/\s+26\s+/g, " and ");
	s = s.replace(/\s*&\s*/g, " and ");
	return s.trim();
}
